import {
  LiliFilePickerError,
  LiliFilePickerFileType,
  LiliFileUpload,
} from '@lili/lili-frontend-common';
import { t } from 'i18next';
import type { LiliFileUploadProps } from '@lili/lili-frontend-common';

export const FileUploadFileType = LiliFilePickerFileType;
export const FileUploadError = LiliFilePickerError;

type FileUploadProps = Omit<LiliFileUploadProps, 'texts'> & { supportedFormats?: string };

export const FileUpload = ({ supportedFormats, ...props }: FileUploadProps) => {
  return (
    <LiliFileUpload
      {...props}
      texts={{
        addAttachment: t('pages.verificationCenter.addAnAttachment'),
        addAttachmentMobile: t('pages.verificationCenter.addAnAttachmentMobile'),
        supportedFormats:
          supportedFormats ?? `${t('pages.verificationCenter.supportedFormates')} PDF, PNG, JPG`,
        uploadFailed: t('pages.verificationCenter.uploadFailed'),
        uploadNewFile: t('pages.verificationCenter.uploadNewFile'),
      }}
    />
  );
};
